<template>
  <div class="navbar flex-center-between">
    <div class="title flex-center">
      <img class="mr10 image-logo pointer" src="@/assets/logo-red.png" alt />
      <div class="fcf fz20 pointer" @click="goHome">{{ baseName }}</div>
    </div>
    <div class="tab-list flex-center">
        <div
            class="tab-item"
            v-for="(item, index) in routeData"
            :key="index"
            :class="currentPath.includes(item.activePath) ? 'tab-item-active' : ''"
            @click="handleClick(item)"
        >
            {{ item.name }}
        </div>
      </div>
    <div>
      <el-dropdown trigger="click" @command="handleCommand" class="pointer">
        <span class="el-dropdown-link">
          <i class="el-icon-user-solid"></i>
          {{ $store.state.account.user.name }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a" v-if="account">切换账号</el-dropdown-item>
          <el-dropdown-item command="b">账户管理</el-dropdown-item>
          <el-dropdown-item command="c" class="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <change-account ref="changeRef"></change-account>
    </div>
  </div>
</template>

<script>
import ChangeAccount from "@/components/ChangeAccount.vue";

export default {
  name: "Navbar",
  components: {
    ChangeAccount,
  },
  data() {
    return {
        path: "",
        routeData: [{
          name: '网签平台',
          path: '',
          activePath: '/sign',
        },{
            name: '印章管理',
            path: '/home',
            activePath: '/home',
        }, {
            name: '用户中心',
            path: '/userCenter/customManage',
            activePath: '/userCenter',
        }, {
            name: '签署记录',
            path: '/document',
            activePath: '/document',
        }],
        account: this.$auth.getAccount() ? JSON.parse(this.$auth.getAccount()) : null,
        currentPath: "",
        baseName: process.env.VUE_APP_API_BASE_NAME,
    };
  },
  watch: {
      // 监听路由对象中的变化
      $route: {
          handler: function (to, from) {
              // 当路由发生变化时会调用这个函数
              // to 和 from 分别代表到达的路由和离开的路由
              this.getRouteChange(to.path);
              // 在这里可以根据路由变化执行相应的逻辑
          },
          // 如果需要在路由变化时立即响应，可以设置immediate为true
          immediate: true,
      },
  },
    methods: {
        getRouteChange() {
            this.currentPath = this.$route.path;
            console.log(this.currentPath)
        },
        handleClick(item) {
            if (item.name === '网签平台'){
              window.location.href = 'http://sign.lngsyz.com/#/home'
              return
            }
            this.$router.push({
                path: item.path,
            });
            this.currentPath = item.path;
        },
        goHome() {
            this.$router.push({
                path: "/home",
            });
        },
        handleCommand(command) {
            switch (command) {
                case "c":
                    this.logOut();
                    break;
                case "b":
                    this.goMyCustom();
                    break;
                case "a":
                    this.$refs.changeRef.show('切换账号');
                    break;
            }
        },
        goMyCustom() {
            this.$router.push({
                path: "/userCenter/customManage",
            });
        },
        logOut() {
          this.$confirm('确定注销并退出系统吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http.get(this.$api.login.logout).then((res) => {
              if (res.data.code == 200) {
                this.$store.commit("account/setUser", null);
                this.$auth.removeToken();
                this.$router.push({
                  path: "/index",
                });
              }
            });
          })

            // window.location.href = 'http://sign.lngsyz.com/#/login'
        },
    },
};
</script>

<style scoped lang="less">
.navbar {
  height: 70px;

  .image-logo {
    width: 24px;
    height: 24px;
  }

  .tab-list {
    font-size: 16px;
    color: #ffffff99;
    // margin-left: 60px;

    .tab-item {
      margin-right: 60px;
      transition: all 0.3s;
      cursor: pointer;
    }

    .tab-item-active {
      color: #fff;
      position: relative;

      &:after {
        position: absolute;
        bottom: -10px;
        left: 0;
        right: 0;
        margin: auto;
        content: "";
        width: 14px;
        height: 3px;
        background: #407fff;
      }
    }
  }

  .logout {
    position: relative;
    margin-top: 6px;
    border-top: 1px solid #e6ebf5;
  }

  ::v-deep .el-dropdown {
    color: #ffffff99;

    &:hover {
      color: #fff;
    }
  }

  ::v-deep .el-icon-arrow-down:before {
    margin-left: 50px;
  }
}
</style>
